module.exports = "<ng-container *ngTemplateOutlet=\"currentView\"></ng-container>";